<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->

<div class="landin-1-api">
    <div class="row" style="position:absolute;z-index:6;width:100vw;margin-left:0px;">
        <div class="hidden-xs col-md-2"></div>
        <div class="col-12 col-md-8 text-landing-1">
            <h1 class="title-landing">Twill studio's Portfolio</h1>
        </div>
    </div>
    <div class="row" style="margin-top:70px;width:100%;margin-left:0px">
        <div class="col-1 col-md-3"></div>
        <div class="col-10 col-md-6">
          <div @click="openModalMobile(true)" class="cardPortfolio">
            <div class="row">
              <div class="col-3 col-md-3">
                <img :src="instaviceMobile" style="width:100%;margin-top:22px;margin-left:19px;">
              </div>
              <div class="col-9 col-md-9">
                <div class="row">
                  <div class="col-md-12 titleCard">
                    Instavice - IOS
                  </div>
                  <div class="col-md-12 subtitleCard">
                    Get the best medical appoitment around you.
                  </div>
                  <div class="col-md-12 subtitleCard">
                    React native + Redux + Firebase
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 col-md-3"></div>
    </div>
    <div class="row" style="margin-top:20px;width:100%;margin-left:0px">
        <div class="col-1 col-md-3"></div>
        <div class="col-10 col-md-6">
          <div @click="openModalWeb(true)" class="cardPortfolio">
            <div class="row">
              <div class="col-3 col-md-3">
                <img :src="webInstavice" style="width:100%;margin-top:22px;margin-left:19px;">
              </div>
              <div class="col-9 col-md-9">
                <div class="row">
                  <div class="col-md-12 titleCard">
                    Instavice - Web
                  </div>
                  <div class="col-md-12 subtitleCard">
                    Help private clinics organise their timetable.
                  </div>
                  <div class="col-md-12 subtitleCard">
                    VueJS + Vuex + Firebase
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 col-md-3"></div>
    </div>
    <div class="row" style="margin-top:20px;width:100%;margin-left:0px">
        <div class="col-1 col-md-3"></div>
        <a href="https://test.yunomusic.com" class="col-10 col-md-6" target="_blank" style="text-decoration: none;">
          <div class="cardPortfolio" style="margin-bottom:20px">
            <div class="row">
              <div class="col-3 col-md-3">
                <img :src="logoYuno" style="width:100%;margin-top:22px;margin-left:19px;">
              </div>
              <div class="col-9 col-md-9">
                <div class="row">
                  <div class="col-md-12 titleCard">
                    Yunö Music
                  </div>
                  <div class="col-md-12 subtitleCard">
                    Find your music event in seconds, anywhere.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
        <div class="col-1 col-md-3"></div>
    </div>
    <div class="row" style="margin-top:20px;width:100%;margin-left:0px">
        <div class="col-1 col-md-3"></div>
        <a href="https://sofiapulseapp.firebaseapp.com/#/" class="col-10 col-md-6" target="_blank" style="text-decoration: none;">
          <div class="cardPortfolio" style="margin-bottom:20px">
            <div class="row">
              <div class="col-3 col-md-3">
                <img :src="sofiaLogo" style="width:100%;margin-top:22px;margin-left:19px;">
              </div>
              <div class="col-9 col-md-9">
                <div class="row">
                  <div class="col-md-12 titleCard">
                    Sofia Pulse
                  </div>
                  <div class="col-md-12 subtitleCard">
                    SofiaPulse is an NLG platform that helps brands connect better with<br> their audiences (alpha version).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
        <div class="col-1 col-md-3"></div>
    </div>
    <transition name="modal" >
    <div v-if="showMobileInstavice" class="modal-mask">
      <div class="modal-container">
        <div class="row">
          <div class="col-12 col-md-4 titleCard2">
            Instavice - IOS
          </div>
          <div class="col-3 col-md-2" style="margin-left:20px">
            <img :src="appStore" style="width:50px;">
          </div>
          <div class="col-2 col-md-2">
            <img :src="react" style="width:50px;">
          </div>
          <div class="col-3 col-md-2">
            <img :src="firebase" style="width:70px;">
          </div>
          <div class="col-2 col-md-1" style="">
            <img :src="instaviceMobile" style="width:50px;margin-right:9px">
          </div>
          <div class="col-md-12 subtitleCard">
            Description: Get the best medical appoitment around you.
          </div>
          <div class="col-md-12 subtitleCard">
            Technology: React native + Redux + Firebase
          </div>  
          <div class="col-md-3">
            <img :src="appIOS1" style="width:100%;margin-top:20px">
          </div>
          <div class="col-md-3">
            <img :src="appIOS2" style="width:100%;margin-top:10px">
          </div>
          <div class="col-md-3">
            <img :src="appIOS3" style="width:100%;margin-top:10px">
          </div>
          <div class="col-md-3">
            <img :src="appIOS4" style="width:100%;margin-top:10px">
          </div>     
          </div>
          <div class="row rowbuttonCloseIOS">
            <div class="buttonCloseIOS" v-on:click="openModalMobile(false)">
            Close
          </div>  
        </div>     
      </div>
    </div>
    </transition>
    <transition name="modal" >
    <div v-if="showWebInstavice" class="modal-mask">
      <div class="modal-container">
        <div class="row">
          <div class="col-md-6 titleCard2">
            Instavice - Web
          </div>
          <div class="col-md-2">
            <img :src="vue" style="width:75px;">
          </div>
          <div class="col-md-2">
            <img :src="firebase" style="width:70px;">
          </div>
          <div class="col-md-1" style="">
            <img :src="instaviceMobile" style="width:50px;margin-right:9px">
          </div>
          <div class="col-md-12 subtitleCard">
            Help private clinics organise their timetable.
          </div>
          <div class="col-md-12 subtitleCard">
            VueJS + Vuex + Firebase
          </div>  
          <div class="col-md-12">
            <img :src="web1" style="width:100%;margin-top:20px">
          </div>
          <div class="col-md-12">
            <img :src="web2" style="width:100%;margin-top:10px">
          </div>    
          </div>
          <div class="row rowbuttonCloseIOS">
            <div class="buttonIOS" v-on:click="openModalWeb(false)">
            Close
          </div>  
        </div>  
          <div class="row rowbuttonIOS">
            <a href="https://instavice.co/" target="_blank" class="buttonCloseIOS" v-on:click="openModalWeb(false)">
            Try it
          </a>  
        </div>    
      </div>
    </div>
    </transition>
</div>
</template>

<script scoped>

export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    hire: require('./assets/img/discover/hire.svg'),
    instaviceMobile: require('./assets/img/portfolio/instaviceMobile.svg'),
    webInstavice: require('./assets/img/portfolio/webInstavice.png'),
    logoYuno: require('./assets/img/portfolio/logoYuno.png'),
    sofiaLogo: require('./assets/img/portfolio/sofiaLogo.png'),
    appStore: require('./assets/img/portfolio/appStore.svg'),
    showMobileInstavice: false,
    showWebInstavice: false,
    vue: require('./assets/img/discover/vue.png'),
    firebase: require('./assets/img/discover/firebase.png'),
    react: require('./assets/img/discover/react.jpg'),
    appIOS1: require('./assets/img/portfolio/appInstavice/appIOS1.png'),
    appIOS2: require('./assets/img/portfolio/appInstavice/slide1.jpg'),
    appIOS3: require('./assets/img/portfolio/appInstavice/slide2.jpg'),
    appIOS4: require('./assets/img/portfolio/appInstavice/slide3.jpg'),
    web1: require('./assets/img/portfolio/webInstavice/web1.png'),
    web2: require('./assets/img/portfolio/webInstavice/web2.png')
  }
  },
    methods: {
      openModalMobile: function openModalMobile(value) {
        this.showMobileInstavice = value;
      },
      openModalWeb: function openModalMobile(value) {
        this.showWebInstavice = value;
      }
  }
  }
</script>
<style scoped>
/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.landin-1-api{
  height:auto;
  position:relative;
/* 5: */
background-image: linear-gradient(-134deg, #F6D365 0%, #FDA085 100%);
  padding-top:100px;
  width:100%;
}
.cardPortfolio{
  height:230px;
  background-color:white;
  border-radius:9px;
  transition: transform 1s;
}

.cardPortfolio:hover{
  /* Rectangle 9: */
box-shadow: 0 8px 19px 0 rgba(0,0,0,0.20);
transform: translate(0px, -5px);
cursor: pointer;
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
  position:absolute;
  overflow: scroll;
    width: 80%;
    margin: 40px auto 0;
    margin-top:80px;
    margin-left:10%;
    height:580px;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.text-landing-1{
    padding-top:0px;
    text-align:center;
    font-weight: bold;
}
.landin-1-api{
  height:auto;
  position:relative;
/* 5: */
background-image: linear-gradient(-134deg, #F6D365 0%, #FDA085 100%);
  padding-top:100px;
  width:100%;
}
.cardPortfolio{
  height:200px;
  background-color:white;
  border-radius:9px;
  transition: transform 1s;
}

.cardPortfolio:hover{
  /* Rectangle 9: */
box-shadow: 0 8px 19px 0 rgba(0,0,0,0.20);
transform: translate(0px, -5px);
cursor: pointer;
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
  position:absolute;
  overflow: scroll;
    width: 800px;
    margin: 40px auto 0;
    margin-top:80px;
    margin-left:23%;
    height:580px;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
}
.titleCard{
  font-size:19px;
  color:#4A4A4A;
  margin-top:34px;
  margin-left:14px;
  font-weight:bold
}

.titleCard2{
  font-size:22px;
  color:#4A4A4A;
  margin-top:14px;
  margin-left:14px;
}

.subtitleCard{
  font-size:15px;
  color:#4A4A4A;
  margin-top:20px;
  margin-left:14px;
  margin-right:14px;  
}


.title-landing{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
margin-bottom:19px;
font-weight:normal;
}

.subtitle-landing{
     font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(199, 198, 198);
font-size:26px;
font-weight:normal; 
}

.landin-2-website{
  height:750px;
 background-color:white;
  width:100%;
  padding-top:800px;
}


.rowbuttonCloseIOS{
  position:absolute;
  bottom:50px;
  right:130px;

}
.rowbuttonIOS{
  position:absolute;
  bottom:50px;
  right:260px;

}
.buttonCloseIOS{
  background-color:#16466B;
  position:fixed;
  width:100px;
  text-align:center;
  height:35px;
  border-radius:6px;
  border: 1px solid #16466B;
  padding-top:5px;
  color:white;
  text-decoration: none;
}
.buttonCloseIOS:hover{
  background-color:#4A90E2;
  border: 1px solid #16466B;
  color:white;
  cursor: pointer;
}
.buttonIOS{
  background-color:white;
  position:fixed;
  width:100px;
  text-align:center;
  height:35px;
  border-radius:6px;
  border: 1px solid #16466B;
  padding-top:5px;
  color:#16466B;
}
.buttonIOS:hover{
  background-color:#16466B;
  border: 1px solid #16466B;
  color:white;
  cursor: pointer;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/portfolio.vue